import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../lib/cn.js";

export type HeadingLevel = "h1" | "h2" | "h3" | "h4";

export type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  readonly level?: HeadingLevel;
};

const LEVEL_CLASS: Record<HeadingLevel, string> = {
  h1: "text-3xl font-semibold tracking-tight font-display",
  h2: "text-2xl font-semibold tracking-tight font-display",
  h3: "text-lg font-semibold",
  h4: "text-base font-semibold",
};

export const Heading = forwardRef<HTMLHeadingElement, HeadingProps>(
  function Heading({ level = "h2", className, ...rest }, ref) {
    const Tag = level;
    return (
      <Tag
        ref={ref}
        className={cn("text-fg", LEVEL_CLASS[level], className)}
        {...rest}
      />
    );
  },
);
